import { Text } from "@eo-locale/react";
import React, { Component } from "react";
import { Card, CardColumns, Container } from "react-bootstrap";
import Header from "./Header";

class Cosmetics extends Component {
  render() {
    function importAll(r) {
      let images = {};
      r.keys().map((item, index) => {
        images[index] = r(item);
        return null;
      });
      return images;
    }

    const images = importAll(
      require.context("../img/cosmetics", false, /\.(png|jpe?g|svg)$/)
    );

    return (
      <div className="white_page cosmetics-page">
        <Header title={<Text id="cosmeticsPage.pageName" />} />
        <Container>
          <CardColumns className="cosmetics-columns">
            {Object.keys(images).map((key) => (
              <Card className="cosmetics-card" key={key}>
                <Card.Img className="cosmetics-img" variant="top" src={images[key]} loading="lazy" />
              </Card>
            ))}
          </CardColumns>
        </Container>
      </div>
    );
  }
}

export default Cosmetics;
